export const STOP_AUTO_RENEW_START = 'STOP_AUTO_RENEW_START';
export const STOP_AUTO_RENEW_SUCCESS = 'STOP_AUTO_RENEW_SUCCESS';
export const STOP_AUTO_RENEW_ERROR = 'STOP_AUTO_RENEW_ERROR';
export const STOP_AUTO_RENEW_LOADING = 'STOP_AUTO_RENEW_LOADING';
export const STOP_AUTO_RENEW_CANCEL = 'STOP_AUTO_RENEW_CANCEL';

export type Actions = {
  STOP_AUTO_RENEW_START: { type: typeof STOP_AUTO_RENEW_START; payload: boolean };
  STOP_AUTO_RENEW_LOADING: { type: typeof STOP_AUTO_RENEW_LOADING; payload: boolean };
  STOP_AUTO_RENEW_SUCCESS: { type: typeof STOP_AUTO_RENEW_SUCCESS; payload: any };
  STOP_AUTO_RENEW_ERROR: { type: typeof STOP_AUTO_RENEW_ERROR; payload: any };
  STOP_AUTO_RENEW_CANCEL: { type: typeof STOP_AUTO_RENEW_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  stopAutoRenewStart: (payload: any): Actions[typeof STOP_AUTO_RENEW_START] => ({
    type: STOP_AUTO_RENEW_START,
    payload,
  }),
  stopAutoRenewError: (payload: any): Actions[typeof STOP_AUTO_RENEW_ERROR] => ({
    type: STOP_AUTO_RENEW_ERROR,
    payload,
  }),
  stopAutoRenewSuccess: (payload: any): Actions[typeof STOP_AUTO_RENEW_SUCCESS] => {
    return ({ type: STOP_AUTO_RENEW_SUCCESS, payload: payload});
  },
  stopAutoRenewLoading: (payload: boolean): Actions[typeof STOP_AUTO_RENEW_LOADING] => ({
    type: STOP_AUTO_RENEW_LOADING,
    payload,
  }),
  stopAutoRenewCancel: (payload: boolean): Actions[typeof STOP_AUTO_RENEW_CANCEL] => ({
    type: STOP_AUTO_RENEW_CANCEL,
    payload,
  }),
};
